import React, {useEffect} from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../style/highpressure.css';
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-highpressure3.png";
import imgServ2 from "../images/photo-highpressure1.png";
import imgServ3 from "../images/photo-highpressure4.png";
import imgServ4 from "../images/photo-highpressure.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Highpressurecleaning() {
    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0);
      }, []);
    
      return (
        <div className="continer-office-cleaning">
          <div className="cover-img-content-pressure">
            <div className="photocontent-box">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--mainColor)",
                  fontFamily: "var(--fontFamily)",
                  fontWeight: "medium",
                }}
              >
                Hochdruckreinigung
              </Typography>
            </div>
          </div>
          <div className="content-text-for-services">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
        fontWeight: '700',
                }}
              >
                Willkommen zu unserem Hochdruckreinigung!
              </Typography>
            </div>
            <div
              className="text-body-service"
              data-aos="zoom-out"
              data-aos-anchor-placement="top-bottom"
              data-aos-offset="100"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <Typography
                gutterBottom
                variant="body2"
                sx={{
                  fontWeight: "normal",
                  fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}
              >
              Unser Hochdruckreinigungsservice bietet professionelle Reinigungslösungen für alle Arten von Oberflächen, sei es in Wohnhäusern, Bürogebäuden, Geschäften oder anderen gewerblichen Einrichtungen. Wir verstehen, dass eine gründliche Reinigung mit Hochdruck nicht nur für eine ästhetisch ansprechende Umgebung wichtig ist, sondern auch für die Wartung und den Werterhalt Ihrer Immobilie. 
                <br /> Unsere erfahrenen Reinigungsteams verwenden hochwertige Reinigungsmittel und modernste Ausrüstung, um eine effektive Reinigung Ihrer Oberflächen zu gewährleisten. Wir kümmern uns um Einfahrten, Gehwege, Terrassen, Fassaden, Parkplätze und mehr. Egal, ob es sich um eine regelmäßige Reinigung oder eine spezielle Reinigung nach Bedarf handelt, wir sind hier, um Ihre Anforderungen zu erfüllen.
                <br />Mit unserem Hochdruckreinigungsservice können Sie sich darauf verlassen, dass Ihre Oberflächen gründlich gereinigt werden und wieder wie neu aussehen. Kontaktieren Sie uns noch heute, um Ihre Reinigungsanforderungen zu besprechen und ein maßgeschneidertes Angebot zu erhalten.
              <br />Wir sind stolz darauf, unseren Kunden saubere und gepflegte Oberflächen zu bieten, die das Erscheinungsbild ihrer Immobilie verbessern. Kontaktieren Sie uns noch heute, um mehr über unsere Hochdruckreinigungsdienste zu erfahren und ein kostenloses Angebot zu erhalten.
              </Typography>
            </div>
            <div className="textandphoto-service">
              <div
                className="text-service-line"
                data-aos="fade-right"
                data-aos-offset="50"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Fachkundige und zuverlässige Reinigungsteams
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
               
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Verwendung umweltfreundlicher Reinigungsmittel
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Maßgeschneiderte Reinigungslösungen, die Ihren Bedürfnissen entsprechen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktlichkeit und Effizienz bei der Arb
                </Typography>
                
                
               
              </div>
              <div className="photo-service-line">
                <div
                  className="photo1-service"
                  data-aos="flip-left"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ1}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo2-service"
                  data-aos="flip-right"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ2}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content-text-for-services2">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
                  fontWeight: '700',
                }}
              >
                Entdecken Sie die Vorteile unserer Hochdruckreinigung!
              </Typography>
            </div>
            <div className="text-body-service2">
              <div
                className="text-for-service-body"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-offest="200"
                data-aos-duration="1000"
              >
                <Typography gutterBottom variant="body2" sx={{
                   fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}>
                  Unser Engagement für Qualität erstreckt sich auf alle unsere Dienstleistungen, einschließlich unserer hoch bewerteten Reinigungsdienste. Egal, ob Sie einen Wohnungsreinigungsdienst in der Nähe Ihrer Stadt benötigen oder professionelle gewerbliche Reinigungslösungen suchen, wir sind für Sie da. Darüber hinaus unterstützen wir auch soziale und wohltätige Zwecke durch unsere Reinigungsdienste. Kontaktieren Sie uns noch heute für eine unübertroffene Reinigungserfahrung!               </Typography>
              </div>
            </div>
            <div className="textandphoto-service2">
              <div
                className="text-service-line2"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Professionelle Reinigung für alle Arten von Hochdruckreinigung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                 
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Gründliche Entfernung von Schmutz, Staub und Rückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Streifenfreie und glänzende Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktliche und zuverlässige Dienstleistungen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wettbewerbsfähige Preise und transparente Abrechnung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Hochbewertete Reinigung.
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wohnungsreinigungsdienst in der Nähe von Städten
                </Typography>
              </div>
              <div className="photo-service-line2">
                <div
                  className="photo3-service"
                  data-aos="flip-left"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ4}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo4-service"
                  data-aos="flip-right"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ3}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    
          <Infokontakt />
          <Footer />
        </div>
      );
}

export default Highpressurecleaning
